import React, { useState, useEffect } from 'react';
import { X, Shield } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const CookieNotice = () => {
  const { language } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);

  const translations = {
    en: {
      message: "No snoopers here! 🔒 YourBuySite only uses cookies to keep you logged in. Your data stays yours.",
      accept: "Got it",
    },
    nl: {
      message: "Geen gluurders hier! 🔒 YourBuySite gebruikt alleen cookies om je ingelogd te houden. Jouw data blijft van jou.",
      accept: "Begrepen",
    },
    es: {
      message: "¡Sin fisgones aquí! 🔒 YourBuySite solo usa cookies para mantenerte conectado. Tus datos son tuyos.",
      accept: "Entendido",
    }
  };

  // Default to Dutch for this NL-focused site
  const txt = translations[language] || translations.nl;

  useEffect(() => {
    // Check if user has already accepted
    const hasAccepted = localStorage.getItem('cookieNoticeAccepted');
    
    if (!hasAccepted) {
      // Show immediately on first visit
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieNoticeAccepted', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div 
      className="fixed bottom-20 sm:bottom-6 left-4 right-4 sm:left-auto sm:right-6 z-[100] animate-in slide-in-from-bottom-4 fade-in duration-300"
      data-testid="cookie-notice"
    >
      <div className="w-full sm:w-auto sm:min-w-[340px] sm:max-w-[400px] bg-card/95 backdrop-blur-md border border-border rounded-2xl shadow-2xl overflow-hidden">
        <div className="p-3 sm:p-4">
          {/* Header row */}
          <div className="flex items-start gap-3">
            {/* Icon */}
            <div className="w-10 h-10 sm:w-11 sm:h-11 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl flex items-center justify-center shadow-lg flex-shrink-0">
              <Shield className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
            </div>
            
            {/* Text content */}
            <div className="flex-1 min-w-0">
              <div className="flex items-start justify-between gap-2">
                <p className="text-sm text-foreground leading-snug">
                  {txt.message}
                </p>
                
                {/* Close button */}
                <button
                  onClick={handleAccept}
                  className="p-1 text-muted-foreground hover:text-foreground hover:bg-secondary rounded-full transition-colors flex-shrink-0 -mt-0.5 -mr-1"
                  aria-label="Close"
                >
                  <X className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>

          {/* Action button */}
          <div className="flex items-center gap-2 mt-3">
            <button
              onClick={handleAccept}
              className="flex-1 flex items-center justify-center gap-1.5 px-3 py-2 bg-primary text-white rounded-xl font-medium text-sm hover:bg-primary/90 transition-colors"
              data-testid="cookie-accept-btn"
            >
              {txt.accept}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieNotice;
